<template>
  <div class="head_body" :class="routerName=='/home'?'bg_3A3B66 col_f':'bg_f col_o'">
    <div class="compony_name">
			<img class="compony_logo" src="@/assets/logo01.png" alt="" v-show="routerName!='/home'"/>
			<img class="compony_logo" src="@/assets/logo02.png" alt="" v-show="routerName=='/home'"/>
			<span class="compony_text" :class="routerName=='/home'?'bg_3A3B66 col_fff':'bg_f col_o'">衡运维</span>
		</div>
		<div class="nav_box">
			<div class="nav_name" :class="routerName=='/home'?'nav_name_checked col_fff':'col_181818'" @click="navRouter('/home')">
				首页
				<div class="nav_line nav_line_home"></div>
			</div>
			<div class="nav_name" :class="routerName=='/painPoints'?'nav_name_checked col_181818':''" @click="navRouter('/painPoints')">痛点分析<div class="nav_line"></div></div>
			<div class="nav_name" :class="routerName=='/solution'?'nav_name_checked col_181818':''"  @click="navRouter('/solution')">解决方案<div class="nav_line"></div></div>
			<div class="nav_name" :class="routerName=='/highlights'?'nav_name_checked col_181818':''" @click="navRouter('/highlights')">平台亮点<div class="nav_line"></div></div>
			<div class="nav_name" :class="routerName=='/componyIntroduce'?'nav_name_checked col_181818':''" @click="navRouter('/componyIntroduce')">公司介绍<div class="nav_line"></div></div>
		</div>
  </div>
</template>

<script>
export default {
  name: 'headComponents',
	data(){
		return{
			routerName:'/home'
		}
	},
	watch: {
	  $route: function (val) {
	    this.routerName = val.path
	  }  
	},
	methods:{
		navRouter(name){
			if(this.routerName==name){return}
			this.routerName = name
			this.$router.push(name)
		}
	}
}
</script>
<style scoped>
	.bg_3A3B66{background: #3A3B66;}
	.bg_f{background: rgba(255, 255, 255, 0.1);}
	.col_f{color: rgba(255, 255, 255, 0.6);}
	.col_o{color: rgba(24, 24, 24, 0.8);}
	.col_fff{color:#fff;}
	.col_181818{color:#181818;}
	.head_body{
		width: 100%;
		min-width: 1200px;
		cursor: pointer;
		height: 70px;
		line-height: 70px;
		
	}
	.compony_name{
		box-sizing: border-box;
		padding-left:40px;
		width: 180px;
		display: inline-block;
		font-size: 24px;
		margin-right:50px;
	}
	.compony_logo{width: 30px;vertical-align: sub;margin-right: 14px;position: relative;top:3px;}
	.compony_text{position: relative;top:4px;}
	.nav_box{
		display: inline-block;
		font-size: 18px;
	}
	.nav_name{
		margin-right:80px;
		display: inline-block;
	}
	.nav_name .nav_line{
		display: none;
	}
	.nav_name_checked .nav_line{
		width:20px;
		height:4px;
		background: #3A3B66;
		border-radius: 10px;
		position: relative;
		top:-4px;
		margin:0 auto;
		display: block;
	}
	.nav_name_checked .nav_line_home{
		background: #FFFFFF;
	}
</style>
